import { getAuth, inMemoryPersistence } from 'firebase/auth';
import { initializeApp } from 'firebase/app';

// Функция для настройки пользовательского обработчика аутентификации
export const setupCustomAuthHandler = () => {
  // Проверяем, не является ли текущая страница bridge-страницей
  if (window.location.pathname.includes('auth-bridge.html')) {
    console.log('На странице аутентификации, пропускаем настройку');
    return;
  }
  
  // Проверяем наличие параметров аутентификации в URL
  const hasAuthParams = window.location.search.includes('code=') || 
                         window.location.search.includes('state=');
  
  if (hasAuthParams) {
    console.log('Обнаружены параметры аутентификации, обрабатываем');
    
    // Настройка Firebase Auth для использования только памяти (без локального хранилища)
    // Это помогает избежать конфликтов между разными способами хранения авторизации
    const auth = getAuth();
    auth.setPersistence(inMemoryPersistence);
    
    // Очищаем URL после обработки
    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
};

// Вызываем эту функцию автоматически при импорте
setupCustomAuthHandler(); 